const type = 'standard'
const path = '/standard/html-php/'
const name = 'server.php'

export { type, path, name }
